import React from 'react';

interface AvatarProps {
  className?: string;
  children?: React.ReactNode;
}

export function Avatar({
  className = '',
  children,
  ...props
}: AvatarProps & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

interface AvatarImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
}

export function AvatarImage({
  className = '',
  src,
  alt = '',
  ...props
}: AvatarImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={`aspect-square h-full w-full object-cover ${className}`}
      {...props}
    />
  );
}

interface AvatarFallbackProps {
  className?: string;
  children?: React.ReactNode;
}

export function AvatarFallback({
  className = '',
  children,
  ...props
}: AvatarFallbackProps & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`flex h-full w-full items-center justify-center rounded-full bg-gray-100 text-gray-600 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
} 